import styled from 'styled-components';
import media from '../../../constants/media';
import { Column, Columns } from '../../base/grid';
import DynamicRspImage from '../../base/images/dynamicRspImageBg';
import { H1 } from '../../base/typography';

export const Wrapper = styled.div`
	display: flex;
	align-items: stretch;
	margin: 6rem 0 18rem;
	min-height: 50rem;
`;

export const HeroColumns = styled(Columns)`
	width: 100%;
`;

export const ContentColumn = styled(Column)`
	order: 2;

	${media.tablet`
		order: 1;
	`};
`;

export const ImageColumn = styled(Column)`
	order: 1;

	${media.tablet`
		order: 2;
	`};
`;

export const ContentWrapper = styled.div`
	/* max-width: 42rem; */
	order: 2;

	${media.tablet`
		order: 1;
	`};
`;

export const ButtonWrapper = styled.div`
	margin-top: 3rem;
`;

export const HeroTitle = styled(H1)`
	margin: 4rem 0;
`;

export const HeroImage = styled(DynamicRspImage)`
	height: 100%;
	padding-top: 80%;

	${media.tablet`
		padding-top: 0;
	`};
`;

export const HeroVideo = styled.video`
	width: 100%;
`;

export const VideoSource = styled.source``;

export const HeroSubTitle = styled.div`
	margin-bottom: 4.125rem;
	color: ${({ theme }) => theme.colors.graySummary};
	font-weight: 700;
	line-height: 4rem;
	font-family: ${({ theme }) => theme.fonts.ArimoRegular};
	font-size: 1.8rem;
	line-height: 2rem;

	${media.tablet`
		font-size: 1.8rem;
		line-height: 3rem;
	`};

	${media.desktopSmall`
		font-size: 2rem;
		line-height: 4rem;
	`};
`;
